export enum UIActionTypes {

    CHATROOM = "@@ui/CHATROOM",
    REQUEST = "@@ui/REQUEST",
    AWAITING_SUPERVISOR_OFFER_PACKAGES = "@@ui/AWAITING_SUPERVISOR_OFFER_PACKAGES",
    UPDATE_REQUEST = "UPDATE_REQUEST",
    CLEAR_REQUEST = "CLEAR_REQUEST",
}
